export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/textSegmentationWorker.bf1e5011.worker.js");
}
